import { Input, Spin } from "antd";
import type { TextAreaProps } from "antd/es/input";
import styles from "./index.module.css";
import { useEffect, useState } from "react";

const { TextArea } = Input;

type Props = TextAreaProps & {
  isMessage?: boolean;
  loading?: boolean;
  additionalInfo?: {
    limit: number;
    title: string;
  };
};

export const CustomTextAreaV2 = (props: Props) => {
  const { loading, ...restProps } = props;
  const [text, setText] = useState(props.value !== undefined ? String(props.value) : "");

  useEffect(() => {
    if (props.value !== undefined) setText(String(props.value));
  }, [props.value]);

  const limit = props?.additionalInfo?.limit;
  const isOverLimit = limit !== undefined && text.length > limit;

  return (
    <div className={styles.container}>
      {props?.additionalInfo ? (
        <div className={styles.limitWrapper}>
          <div>{props?.additionalInfo.title}</div>
          <div className={isOverLimit ? styles.limitOver : undefined}>
            {text.length}/{limit}
          </div>
        </div>
      ) : null}
      <Spin spinning={!!loading}>
        <TextArea
          {...restProps}
          onChange={(v) => {
            props?.onChange(v);
            setText(v.target.value);
          }}
          value={text}
          disabled={props.disabled || loading}
          autoSize={props.isMessage ? { minRows: 1, maxRows: 4 } : undefined}
          status={isOverLimit ? "error" : props.status}
          className={`${styles.textArea} ${props.isMessage ? styles.messageTextArea : ""} ${
            props.className ? props.className : ""
          }`}
        />
      </Spin>
      {isOverLimit && <div className={styles.limitError}>Character limit exceeded</div>}
    </div>
  );
};
